import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  // Only the navigation chrome is translated. The policy body below is a legal document:
  // it needs a reviewed translation, not a machine one.
  const { t } = useTranslation("auth");

  return (
    <div className="min-h-dvh bg-[#18181b] text-neutral-100">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-neutral-400 hover:text-neutral-100 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          {t("privacy.back")}
        </Link>

        <div className="flex items-center gap-4 mb-10">
          <img src="/Rolt_branco.svg" alt="ROLT" className="h-8" />
        </div>

        <h1 className="text-3xl font-bold text-neutral-50 mb-2">
          Termo de Privacidade
        </h1>
        <p className="text-neutral-400 mb-10 text-sm">
          Ultima atualizacao: Fevereiro de 2026
        </p>

        <div className="space-y-8 text-[15px] leading-relaxed text-neutral-300">
          <Section title="1. Introducao">
            <p>
              A ROLT valoriza e respeita a privacidade dos seus usuarios e
              clientes. Este Termo de Privacidade descreve como coletamos,
              utilizamos, armazenamos, protegemos e compartilhamos seus dados
              pessoais ao utilizar a ROLT API Oficial WhatsApp e ao acessar
              nosso site e servicos associados.
            </p>
            <p>
              Ao utilizar nossa API e demais servicos oferecidos pela ROLT, voce
              concorda com os termos aqui estabelecidos e declara estar ciente
              das praticas adotadas em relacao a privacidade e seguranca das suas
              informacoes.
            </p>
          </Section>

          <Section title="2. Dados Coletados">
            <p>
              Durante a utilizacao da ROLT API Oficial WhatsApp e do nosso site,
              podemos coletar diversos tipos de informacoes, incluindo, mas nao
              se limitando a:
            </p>

            <SubSection title="2.1. Informacoes fornecidas diretamente pelo usuario">
              <ul className="list-disc pl-5 space-y-1">
                <li>Nome completo ou nome da empresa</li>
                <li>E-mail de contato</li>
                <li>Numero de telefone/WhatsApp</li>
                <li>
                  Credenciais de autenticacao para utilizacao da API
                </li>
                <li>Dados de faturamento e pagamento (quando aplicavel)</li>
              </ul>
            </SubSection>

            <SubSection title="2.2. Informacoes coletadas automaticamente">
              <p>
                Ao acessar nosso site ou utilizar nossa API, algumas informacoes
                podem ser coletadas automaticamente, incluindo:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Endereco IP</li>
                <li>Tipo de navegador e sistema operacional</li>
                <li>Paginas acessadas e tempo de navegacao</li>
                <li>
                  Logs de uso da API e interacoes com nossos servicos
                </li>
                <li>
                  Dados estatisticos sobre desempenho da API e metricas de
                  utilizacao
                </li>
              </ul>
            </SubSection>

            <SubSection title="2.3. Dados obtidos de terceiros">
              <p>
                Podemos coletar informacoes por meio de parceiros, integracoes
                com outras plataformas ou bases de dados publicas, sempre em
                conformidade com a legislacao vigente e com a devida autorizacao
                do usuario quando necessario.
              </p>
            </SubSection>
          </Section>

          <Section title="3. Uso das Informacoes">
            <p>
              As informacoes coletadas sao utilizadas para diversas finalidades,
              incluindo:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong className="text-neutral-100">
                  Fornecimento da API e funcionalidades associadas:
                </strong>{" "}
                Garantir o funcionamento correto da API, autenticacao dos
                usuarios e gestao de acessos.
              </li>
              <li>
                <strong className="text-neutral-100">
                  Melhoria dos servicos:
                </strong>{" "}
                Analisar metricas de uso para otimizar a experiencia do usuario e
                aprimorar a API.
              </li>
              <li>
                <strong className="text-neutral-100">
                  Atendimento ao cliente e suporte tecnico:
                </strong>{" "}
                Auxiliar os usuarios em duvidas, problemas tecnicos e
                solicitacoes.
              </li>
              <li>
                <strong className="text-neutral-100">
                  Seguranca e prevencao de fraudes:
                </strong>{" "}
                Monitoramento de atividades suspeitas e implementacao de medidas
                para protecao contra acessos nao autorizados.
              </li>
              <li>
                <strong className="text-neutral-100">
                  Cumprimento de obrigacoes legais:
                </strong>{" "}
                Atendimento a exigencias regulatorias e fornecimento de
                informacoes quando solicitadas por autoridades competentes.
              </li>
            </ul>
          </Section>

          <Section title="4. Compartilhamento de Informacoes">
            <p>
              A ROLT se compromete a nao vender, alugar ou compartilhar seus
              dados pessoais com terceiros, exceto nos seguintes casos:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong className="text-neutral-100">
                  Parceiros e prestadores de servico:
                </strong>{" "}
                Podemos compartilhar informacoes com fornecedores que nos
                auxiliam na operacao dos servicos, sempre garantindo que sigam
                praticas adequadas de protecao de dados.
              </li>
              <li>
                <strong className="text-neutral-100">
                  Exigencias legais:
                </strong>{" "}
                Quando necessario para cumprimento de determinacoes judiciais,
                regulatorias ou solicitacoes governamentais.
              </li>
              <li>
                <strong className="text-neutral-100">
                  Transferencias empresariais:
                </strong>{" "}
                Em caso de fusao, aquisicao ou venda de ativos da empresa, os
                dados poderao ser transferidos para a nova entidade responsavel.
              </li>
            </ul>
          </Section>

          <Section title="5. Armazenamento e Seguranca dos Dados">
            <p>
              Empregamos medidas de seguranca rigorosas para proteger as
              informacoes dos usuarios contra acessos nao autorizados, perda,
              alteracao ou destruicao. Entre essas medidas estao:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Criptografia de dados sensiveis</li>
              <li>Controle de acessos restritivos</li>
              <li>Monitoramento continuo de atividades na API</li>
              <li>Ambientes protegidos para armazenamento de informacoes</li>
            </ul>
            <p>
              Os dados coletados sao armazenados pelo periodo necessario para
              cumprir com as finalidades descritas neste termo, respeitando as
              obrigacoes legais e regulatorias aplicaveis.
            </p>
          </Section>

          <Section title="6. Direitos dos Usuarios">
            <p>
              Os usuarios da ROLT API Oficial WhatsApp e visitantes do site
              possuem os seguintes direitos em relacao aos seus dados pessoais:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong className="text-neutral-100">Acesso:</strong> Solicitar
                informacoes sobre quais dados foram coletados e como sao
                utilizados.
              </li>
              <li>
                <strong className="text-neutral-100">Correcao:</strong>{" "}
                Atualizar ou corrigir dados incorretos ou desatualizados.
              </li>
              <li>
                <strong className="text-neutral-100">Exclusao:</strong>{" "}
                Solicitar a remocao de dados pessoais, salvo em casos em que a
                retencao seja obrigatoria por lei.
              </li>
              <li>
                <strong className="text-neutral-100">Portabilidade:</strong>{" "}
                Requerer uma copia dos dados em formato estruturado.
              </li>
              <li>
                <strong className="text-neutral-100">
                  Revogacao de consentimento:
                </strong>{" "}
                Retirar a autorizacao para uso de determinados dados quando
                aplicavel.
              </li>
            </ul>
            <p>
              Para exercer qualquer um desses direitos, entre em contato conosco
              pelos canais de atendimento disponiveis.
            </p>
          </Section>

          <Section title="7. Cookies e Tecnologias de Rastreamento">
            <p>
              Nosso site pode utilizar cookies e tecnologias similares para
              aprimorar a experiencia do usuario, coletar informacoes sobre a
              navegacao e melhorar nossos servicos. Voce pode configurar seu
              navegador para bloquear ou alertar sobre o uso de cookies, mas isso
              pode afetar a funcionalidade do site.
            </p>
          </Section>

          <Section title="8. Alteracoes neste Termo de Privacidade">
            <p>
              A ROLT se reserva o direito de atualizar este Termo de Privacidade
              sempre que necessario para refletir mudancas nas praticas da
              empresa, novas regulamentacoes ou melhorias nos servicos. As
              alteracoes serao comunicadas atraves de nossos canais oficiais e
              entrarao em vigor imediatamente apos a publicacao.
            </p>
            <p>
              Recomendamos que voce revise periodicamente este documento para se
              manter informado sobre eventuais mudancas.
            </p>
          </Section>

          <Section title="9. Contato">
            <p>
              Se voce tiver qualquer duvida, solicitacao ou preocupacao
              relacionada a este Termo de Privacidade, entre em contato conosco
              atraves dos seguintes canais:
            </p>
            <p className="mt-2">
              <strong className="text-neutral-100">E-mail:</strong>{" "}
              <a
                href="mailto:falecom@rolt.io"
                className="text-blue-400 hover:text-blue-300 underline transition-colors"
              >
                falecom@rolt.io
              </a>
            </p>
          </Section>

          <div className="border-t border-neutral-600 pt-8 mt-12">
            <p className="text-neutral-400 text-sm">
              Ao continuar utilizando nossos servicos, voce confirma que leu,
              compreendeu e concorda com os termos aqui descritos.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section>
      <h2 className="text-xl font-semibold text-neutral-50 mb-4">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

function SubSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="mt-4">
      <h3 className="text-base font-medium text-neutral-100 mb-2">{title}</h3>
      <div className="space-y-2">{children}</div>
    </div>
  );
}

export default Privacy;
